export default __webpack_public_path__ + "static/media/casa_timis.94a636f2.png";